import { defineMessages } from 'react-intl';

import type { AccountError } from '@/graphql/saleor/api';

import { commonErrorCodeMessages, type FormattedError } from './common';

export const errors = defineMessages({
  invalidOrExpiredToken: {
    id: 'passwordChange.invalidOrExpiredToken',
    defaultMessage: 'Invalid or expired token.',
  },
  userNotFound: {
    id: 'passwordChange.userNotFound',
    defaultMessage: 'User does not exist.',
  },
});

export const getPasswordChangeErrorCodeMessage = (
  error: FormattedError<AccountError>,
) => {
  switch (error.code) {
    case 'INVALID':
      return errors.invalidOrExpiredToken;

    case 'NOT_FOUND':
      return errors.userNotFound;

    default:
      return commonErrorCodeMessages.unexpectedErrorOccurred;
  }
};
